export function setWindowLocationHref(href: string) {
  window.location.href = href
}

export function getWindowLocationInfos() {
  return {
    pathname: window.location.pathname,
    origin: window.location.origin,
  }
}
